/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Action, State } from '../redux';

const initialState: State['document'] = {
  currentDoc: undefined,
  documents: [],
  selectedDoc: undefined,
  editUrl: undefined,
};

export function documentReducer(state = initialState, action: Action) {
  switch (action.type) {
    case 'SET_CURRENT_DOC':
      return {
        ...state,
        currentDoc: action.payload,
      };
    case 'SET_DOCUMENTS':
      return {
        ...state,
        documents: [...action.payload],
      };
    case 'SET_SELECTED_DOC':
      return {
        ...state,
        selectedDoc: action.payload,
      };
    case 'SET_EDIT_URL':
      return {
        ...state,
        editUrl: action.payload,
      };
    default:
      return state;
  }
}
